/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
var iswHideVendorList = ["6009", "81702", "82338", "83316", "83432", "83900", "83980", "84643", "84864", "84883", "84913", "85464", "85828", "fcl", "befame", "lcl", "venture", "cs", "designlink", "china", "twenty", "actona", "unique", "furniture", "malaysia", "connect", "cavo", "house", "nordic", "dominari", "tvilum", "ukraine", "turkey", "house", "nordic", "poland", "doing", "goods", "present", "time", "core", "one", "lexpo", "jakobsen", "home", "jakobsen", "home", "design", "link", "guardian", "liv", "interior"];

// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

  // Clear button for the Form Search
  HTMLDocument.prototype.ready = function () {
    return new Promise(function(resolve, reject) {
      if (document.readyState === 'complete') {
        resolve(document);
      } else {
        document.addEventListener('DOMContentLoaded', function() {
          resolve(document);
        });
      }
    });
  }
  
  document.ready().then(function(){
    var inputSearchFormSelector = jQ('.boost-pfs-search-input');
    var clearSearchFormSelector = jQ('.boost-pfs-search-form-btn-clear');

    if(!!inputSearchFormSelector.val()) {
      clearSearchFormSelector.show();
    }
    
    inputSearchFormSelector.on('change keydown keyup', function(){
      if(!!jQ(this).val()) {
        clearSearchFormSelector.show();
      } else {
        clearSearchFormSelector.hide();
      }
    })

    clearSearchFormSelector.on("click", function(){
      inputSearchFormSelector.val("");
      jQ(this).hide();
      inputSearchFormSelector.click();
    });
  })// End Clear button for the Form Search
  

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  // Fix search redirect - conflict theme js
    const getSearchRedirectUrl = () => {
    	if (typeof Globals.currentTerm !== 'string'){
    		Globals.currentTerm = Utils.stripHtml(Globals.currentTerm.toString());
    	}
    	Globals.currentTerm = Utils.stripHtml(Globals.currentTerm.trim());
    
    	var redirectUrl = '';
    	if (Globals.suggestionCache.hasOwnProperty(Utils.unescape(Globals.currentTerm))) {
    		var cachedResult = Globals.suggestionCache[Utils.unescape(Globals.currentTerm)];
    		cachedResult.forEach((result) => {
    			if (result.key == 'redirect' && result.values) {
    				// Check is there is a redirect
    				redirectUrl = result.values;
    				redirectUrl = redirectUrl.replace('https://' + Globals.shopDomain, '');
    				redirectUrl = redirectUrl.replace('http://' + Globals.shopDomain, '');
    			}
    		});
    	}
    	return redirectUrl;
    }

  const mySearchBtn = document.querySelectorAll('form[action="/search"] button[type="submit"]');
    mySearchBtn.forEach(function(el){
      let new_el = el.cloneNode(true);
      el.after(new_el);
      el.remove();
      new_el.addEventListener('click', function(e) {
        // e.stopImmediatePropagation();
        // e.stopPropagation();
        // e.preventDefault();
        if(Object.entries(Globals.suggestionCache).length > 0){
          var redirectUrl = getSearchRedirectUrl();
          if (redirectUrl) {
              Utils.setWindowLocation(redirectUrl);
          } else {
              // document.querySelectorAll('form[action="/search"]')[0].submit();
          }
        }else{
          jQ('[name="q"]').click();
        }
      });
    });

    SearchInput.prototype._bindAutoCompleteSource = function(request, response) {
		window.suggestionCallback = response;
		Globals.currentTerm = Utils.stripHtml(request.term);
		var term = (request.term).trim().replace(/\s+/g, ' ');
		if (term != '') {
          
            // Hide vendor group
            var isExcluded = false;
            var lowerTerm = term.toLowerCase();
            for (let i = 0; i < iswHideVendorList.length; i++) {
              if(iswHideVendorList[i].includes(lowerTerm)){
                isExcluded = true;
              }
            }
            for (let i = 0; i < iswHideVendorList.length; i++) {
              if(lowerTerm.includes(iswHideVendorList[i])){
                isExcluded = true;
              }
            }
            if(isExcluded){
              jQ('body').addClass('boost-pfs-hide-isw-other-groups');
            }else{
              jQ('body').removeClass('boost-pfs-hide-isw-other-groups');
            }
          
			var $instantSearchResult = this.searchAutoComplete.$element;
			this.instantSearchResult.setData($instantSearchResult, null, true);
			this.instantSearchResult.refresh();
			if (Globals.suggestionCache.hasOwnProperty(term)) {
				window.suggestionCallback(Globals.suggestionCache[term]);
				return;
			}
			term = encodeURIComponent(term);
			InstantSearchApi.getSuggestionData(term, 0, 'suggest');
		}
	};

})();